import React, { useEffect, useRef } from 'react'
import Project from './Project'
import './projects.css'
import { projectEntries } from '../../data/ProjectEntries';
import useIntersection from '../../hooks/useIntersection';
import { FaArrowLeft, FaArrowRight, FaChevronDown } from 'react-icons/fa';

const PAGE_SIZE = 5

function Projects() {
  const [page, setPage] = React.useState(1)
  return (
    <div className="projects" id="projects">
      <h1>projects.</h1>
      <h3>check out some of my projects!</h3>
      {Array.from({ length: page + 1 }, (_, i) => i + 1).map(i =>
        <div key={i} className={i === page + 1 ? "hidden" : "project-page"}>
          {projectEntries.slice((i - 1) * PAGE_SIZE, i * PAGE_SIZE).map((entry, i) =>
            <Project key={i} {...entry} />
          )}
        </div>
      )}
      {page * PAGE_SIZE < projectEntries.length &&
        <div className="projects-more">
          <span onClick={() => setPage(prev => prev + 1)}>View more projects<FaChevronDown /></span>
        </div>
      }
    </div>
  )
}

export default Projects
